/**
 * Voice-changer settings. The runtime pipeline is now STT → TTS
 * (Faster-Whisper + Edge-TTS), so the "model" a user selects is simply
 * the id of an Edge-TTS voice preset in `shared/tts.ts`. We keep this
 * module separate so the historical name `voiceChanger` (persisted in
 * `bot_settings`) stays a clean, self-documenting key.
 */

export type VoiceChangerSettings = {
    enabled: boolean
    /**
     * Edge-TTS voice id, e.g. `zh-CN-XiaoxiaoNeural`. An empty string
     * means "no voice selected" — the server falls back to the first
     * entry in TTS_VOICE_MODELS when it needs to synthesize.
     */
    selectedModelId: string
}

/**
 * Default selection for freshly provisioned accounts. Empty string
 * intentionally — users should actively pick a voice before flipping
 * the master switch.
 */
export const DEFAULT_VOICE_CHANGER_MODEL_ID = ''
